export const getTransform = (transform = ''): string => {
    const transformSplit = transform.split('m')
    return transform ? `matrix(${transformSplit[1]})` : transform
}
